import React, { useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { CheckCircle, Download, ArrowRight } from 'lucide-react'

const PaymentSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams()
  const orderNumber = searchParams.get('order_id')

  useEffect(() => {
    // Clear cart after successful payment
    // This would typically be handled by the backend
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        <div className="mb-6">
          <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Pembayaran Berhasil!
          </h1>
          <p className="text-gray-600">
            Terima kasih atas pembelian Anda. Pesanan Anda telah berhasil diproses.
          </p>
        </div>

        {orderNumber && (
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-gray-600 mb-1">Nomor Pesanan:</p>
            <p className="font-mono font-semibold text-gray-900">{orderNumber}</p>
          </div>
        )}

        <div className="space-y-3">
          <Link
            to={`/orders`}
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors inline-flex items-center justify-center"
          >
            <Download className="h-5 w-5 mr-2" />
            Lihat Pesanan & Download
          </Link>
          
          <Link
            to="/products"
            className="w-full border border-gray-300 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-50 transition-colors inline-flex items-center justify-center"
          >
            Lanjut Belanja
            <ArrowRight className="h-5 w-5 ml-2" />
          </Link>
        </div>

        <div className="mt-6 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-600">
            File digital Anda sudah tersedia untuk didownload di halaman pesanan.
          </p>
        </div>
      </div>
    </div>
  )
}

export default PaymentSuccessPage
